import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { useFetchTasks } from "src/data/taskManagement/taskManagementQueries"
import { TTaskFetchFilters } from "src/data/taskManagement/taskManagementTypes"

export function useFetchTasksCount(filters: Partial<TTaskFetchFilters>) {
  const { orgId } = useOrganization()

  const fetchTasksCount = useFetchTasks({
    orgId,
    filters: {
      limit: 1,
      offset: 0,
      sort_by: "created_at",
      sort_order: "asc",
      ...filters,
    },
    options: {
      select: (data) => data.paging.total_count,
    },
  })

  return {
    count: fetchTasksCount.data ?? 0,
    loading: fetchTasksCount.isLoading,
  }
}
